import { render, staticRenderFns } from "./create-profile.vue?vue&type=template&id=0b68d71a&scoped=true"
import script from "./create-profile.vue?vue&type=script&lang=js"
export * from "./create-profile.vue?vue&type=script&lang=js"
import style0 from "./create-profile.vue?vue&type=style&index=0&id=0b68d71a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b68d71a",
  null
  
)

export default component.exports